import React from 'react';
import { Text, View} from 'react-native';
import translate from './localization';

const parseNodes = (input) => {
    const root = [];
    const stack = [{ children: root }];

    const tagRegex = /<\/?([a-zA-Z0-9_]+)(\s*\/?)>/g;

    let lastIndex = 0;
    let match;

    while ((match = tagRegex.exec(input))) {
        const [fullMatch, tag, selfClosing] = match;
        const isClosing = fullMatch.startsWith('</');
        const isSelfClosing = selfClosing.includes('/');

        // text before tag
        if (match.index > lastIndex) {
            stack[stack.length - 1].children.push(
                input.slice(lastIndex, match.index)
            );
        }

        if (isSelfClosing) {
            // directly push node without stack
            stack[stack.length - 1].children.push({
                tag,
                selfClosing: true,
            });
        } else if (isClosing) {
            const node = stack.pop();

            stack[stack.length - 1].children.push({
                tag: node.tag,
                children: node.children,
            });
        } else {
            stack.push({
                tag,
                children: [],
            });
        }

        lastIndex = tagRegex.lastIndex;
    }

    if (lastIndex < input.length) {
        stack[stack.length - 1].children.push(
            input.slice(lastIndex)
        );
    }

    return root;
};

const renderNodes = (nodes, components, keyPrefix = '') =>
    nodes.map((node, index) => {
        const key = `${keyPrefix}${index}`;

        if (typeof node === 'string') {
            return node;
        }

        const Component = components[node.tag];

        // self-closing tag like <bullet/>
        if (node.selfClosing) {
            if (React.isValidElement(Component)) {
                return React.cloneElement(Component, { key });
            }

            return null;
        }

        const children = renderNodes(
            node.children,
            components,
            `${key}-`
        );

        // bullet list row layout
        if (node.tag === 'item' || node.tag === 'subitem') {
            const Component = components[node.tag];

            if (typeof Component === 'function') {
                return (
                    <Component
                        key={key}
                        bullet={
                            components.bullet && React.isValidElement(components.bullet)
                                ? React.cloneElement(components.bullet)
                                : null
                        }
                    >
                        {children}
                    </Component>
                );
            }
        }

        if (React.isValidElement(Component)) {
            return React.cloneElement(Component, { key }, children);
        }

        return <React.Fragment key={key}>{children}</React.Fragment>;
    });

export const Trans = ({
                          i18nKey,
                          values = {},
                          components = {},
                      }) => {
    const translation = translate(i18nKey, values);

    const nodes = parseNodes(translation);

    return (
        <Text>
            {renderNodes(nodes, components)}
        </Text>
    );
};
